import { AppPermission } from "@/auth/permissions";
import { permissions as telephony_perms } from "@/telephony/permissions";
export const permissions: AppPermission[] = [telephony_perms];
